export default {"src":"/_next/static/media/spotify.486aceb0.svg","height":40,"width":40};